/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Create_Back_To_UsersInputs */

const en_admin_user_create_back_to_users = /** @type {(inputs: Admin_User_Create_Back_To_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to users`)
};

const de_admin_user_create_back_to_users = /** @type {(inputs: Admin_User_Create_Back_To_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zur Benutzerübersicht`)
};

/**
* | output |
* | --- |
* | "Back to users" |
*
* @param {Admin_User_Create_Back_To_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_create_back_to_users = /** @type {((inputs?: Admin_User_Create_Back_To_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Create_Back_To_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_create_back_to_users(inputs)
	return en_admin_user_create_back_to_users(inputs)
});